import { cn } from "@/lib/utils";
import PropTypes from "prop-types";

/**
 * PulsingLoader - Shows a pulsing avatar while waiting for assistant response
 * Matches the ProviderAvatar structure exactly (same size, border, animation)
 * Shows immediately after user submission and during streaming
 * Uses the 'providerPulse' animation defined in message-content.css
 */
export function PulsingLoader({ className, showAvatar = true }) {
  return (
    <div
      className={cn(
        "grid grid-cols-[auto_1fr] gap-3 sm:gap-4 md:gap-6 items-start w-full",
        className
      )}
    >
      {/* Avatar Column - matches ProviderAvatar structure exactly */}
      {showAvatar && (
        <div className="flex-shrink-0">
          <div
            className={cn(
              "w-5 h-5 rounded-full flex items-center justify-center",
              "bg-transparent border border-gray-300 dark:border-gray-500",
              "shadow-sm mr-2 flex-shrink-0"
            )}
          >
            {/* Pulsing loader icon - matches PulseLoaderIcon from ProviderAvatar */}
            <div
              className="rounded-full bg-gray-400 dark:bg-gray-500"
              style={{
                width: "12px",
                height: "12px",
                animation: "providerPulse 2s ease-in-out infinite",
              }}
            />
          </div>
        </div>
      )}

      {/* Content Column - empty space where message content will appear */}
      <div className="flex items-center min-w-0">
        {/* No additional content needed - just the avatar pulsing is enough */}
      </div>
    </div>
  );
}

PulsingLoader.propTypes = {
  className: PropTypes.string,
  showAvatar: PropTypes.bool,
};

export default PulsingLoader;
